import React from 'react';
import PropTypes from 'prop-types';

import {Icon} from 'semantic-ui-react';

const EmailAddress = ({text,emailAddress,subject,body}) => {    
    text = text && text !== ''? text: 'Send Email';
    let url = 'mailto:' + emailAddress;      
    if (subject || body)    {        
        let args = [];
        if (subject)
            args.push('subject=' + subject);
        if (body)
            args.push('body=' + body);
        url += '?' + args.join('&');
    }

    return (        
        <div>
            <a href={url}>{text}</a>
            <Icon name="external"/>            
        </div>
    );
};

EmailAddress.propTypes = {
    text: PropTypes.string,
    emailAddress: PropTypes.string.isRequired,
    subject: PropTypes.string,
    body: PropTypes.string,
};

export default EmailAddress;